var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'Car-Label',
    ("Car-Label--" + _vm.horizontalPosition),
    ("Car-Label--" + _vm.verticalPosition) ],style:({ transform: ("rotate(" + (_vm.rotation * -1) + "deg)") })},[_vm._m(0),_c('p',{staticClass:"Car-Label__name"},[_vm._v(_vm._s(_vm.vehicleLabel))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Car-Label__gear"},[_c('span',{staticClass:"Car-Label__gear__letter"},[_vm._v("D")])])}]

export { render, staticRenderFns }